import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">PensioenZeker</h3>
            <p className="mb-2">Uw betrouwbare pensioenuitvoerder in Nederland</p>
            <p className="mb-2">KvK: 12345678</p>
            <p className="mb-2">AFM: 87654321</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Snelle Links</h3>
            <ul className="space-y-2">
              <li><a href="#home" className="hover:text-blue-300 transition duration-300">Home</a></li>
              <li><a href="#over-ons" className="hover:text-blue-300 transition duration-300">Over Ons</a></li>
              <li><a href="#pensioenplannen" className="hover:text-blue-300 transition duration-300">Pensioenplannen</a></li>
              <li><a href="#berekenen" className="hover:text-blue-300 transition duration-300">Bereken Uw Pensioen</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <p className="mb-2">Pensioenweg 123</p>
            <p className="mb-2">1234 AB Amsterdam</p>
            <p className="mb-2">Tel: 020-123 45 67</p>
            <p className="mb-2">Email: info@pensioenzeker.nl</p>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-xl font-bold mb-4">Nieuwsbrief</h3>
            <p className="mb-4">Blijf op de hoogte van pensioenveranderingen en onze diensten.</p>
            <div className="flex">
              <input
                type="email"
                placeholder="Uw e-mailadres"
                className="px-4 py-2 w-full text-gray-800 rounded-l focus:outline-none"
              />
              <button className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-r transition duration-300">
                Aanmelden
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p>&copy; {new Date().getFullYear()} PensioenZeker. Alle rechten voorbehouden.</p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <a href="#privacy" className="hover:text-blue-300 transition duration-300">Privacy Policy</a>
            <a href="#voorwaarden" className="hover:text-blue-300 transition duration-300">Algemene Voorwaarden</a>
            <a href="#cookies" className="hover:text-blue-300 transition duration-300">Cookie Beleid</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
